import { render, staticRenderFns } from "./MbAlert.vue?vue&type=template&id=2f8cc196&"
import script from "./MbAlert.vue?vue&type=script&lang=js&"
export * from "./MbAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports